import { render, staticRenderFns } from "./look.vue?vue&type=template&id=0014a694"
import script from "./look.vue?vue&type=script&lang=js"
export * from "./look.vue?vue&type=script&lang=js"
import style0 from "./look.vue?vue&type=style&index=0&id=0014a694&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0014a694')) {
      api.createRecord('0014a694', component.options)
    } else {
      api.reload('0014a694', component.options)
    }
    module.hot.accept("./look.vue?vue&type=template&id=0014a694", function () {
      api.rerender('0014a694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PPT/look.vue"
export default component.exports